// US office date format: every stored ISO date (yyyy-mm-dd) displays as mm/dd/yyyy.
// Anything already in another shape passes through unchanged.
export const fmtDate = (v) => {
  const m = String(v || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[2]}/${m[3]}/${m[1]}` : (v || "");
};

// Same but keeps a trailing time/day suffix (e.g. "2026-08-19 · Mon" -> "08/19/2026 · Mon").
export const fmtDateKeepSuffix = (v) => {
  const s = String(v || "");
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(.*)$/);
  return m ? `${m[2]}/${m[3]}/${m[1]}${m[4]}` : s;
};

// Accepts office-typed mm/dd/yyyy (or mm/dd/yy) and returns ISO for storage; ISO passes through.
export const toISODate = (v) => {
  const s = String(v || "").trim();
  const m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})$/);
  if (!m) return s;
  const yr = m[3].length === 2 ? `20${m[3]}` : m[3];
  return `${yr}-${m[1].padStart(2, "0")}-${m[2].padStart(2, "0")}`;
};
